import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { auth, setAuth } = useAuth();

    const token = auth?.accessToken
    const to = localStorage.getItem("auth")
    const refresh = async () => {
        const response = await axios.get('/auth/refreshtoken', {
            headers: {'Authorization': `Bearer ${to}`}
        });
        setAuth(prev => {
            return {
                ...prev,
                roles: response.data.roles,
                accessToken: response.data.accessToken
            }
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
